import { Stack, StackProps, Typography, TypographyProps } from '@mui/material';

import { fPriceString } from 'src/utils/format-string';

import { SurplusEntry } from 'src/api/models/surplus';

interface Props {
  price: string;
  isEstimate?: boolean;
  surplusEntry?: SurplusEntry | null;
  direction?: StackProps['direction'];
  textVarient?: TypographyProps['variant'];
}

export default function PriceLabel({
  isEstimate,
  surplusEntry,
  price,
  direction,
  textVarient = 'body2',
}: Props) {
  const estSuffix = isEstimate ? ' est' : '';

  if (surplusEntry?.typeOfPrice === 'promotion' && surplusEntry.promotionPrice) {
    const promotionalPrice = fPriceString(surplusEntry.promotionPrice);
    const formattedPrice = fPriceString(price);
    return (
      <Stack direction={direction} columnGap={1} alignItems="center">
        <Typography
          variant={textVarient}
          aria-label={`Discounted price per unit ${promotionalPrice}${estSuffix}.`}
          fontWeight="bold"
        >
          {`£${promotionalPrice}${estSuffix}`}
        </Typography>
        <Typography
          variant={textVarient}
          sx={{ textDecoration: 'line-through' }}
          aria-label={`Original price per unit ${formattedPrice}${estSuffix}`}
        >
          {`£${formattedPrice}`}
        </Typography>
      </Stack>
    );
  }

  if (surplusEntry?.typeOfPrice === 'surplus' && surplusEntry.surplusPrice) {
    const surplusPrice = fPriceString(surplusEntry.surplusPrice);
    return (
      <Typography
        fontWeight="bold"
        variant={textVarient}
        aria-label={`Surplus price per unit ${surplusPrice}${estSuffix}`}
      >
        {`£${surplusPrice}${estSuffix}`}
      </Typography>
    );
  }

  const formattedPrice = fPriceString(price);
  return (
    <Typography variant={textVarient} aria-label={`Price per unit ${formattedPrice}${estSuffix}`}>
      {`£${formattedPrice}${estSuffix}`}
    </Typography>
  );
}
